module.exports = __webpack_public_path__ + "static/img/redeem-tikbee.624cb551.png";